module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Earth-a1263d67000f4f899700b82333e52fa0d541b2f3f7e6efa9829cb796505e4c59.svg";